<template>
  <div class="modalIn">
    <slotModal
      :id-modal="'modalIn'"
      :modal-title="data.title"
      :footer="false"
      v-model="modal"
      @close="close"
      class="titleModal"
    >
      <template v-slot:modal-content>
        <TransaksiContent v-if="data.ref_type == 'snap_transaksi' || data.ref_type == 'snap_transaksi_hapus'"/>
				<TopUpContent v-if="data.ref_type == 'pembelian_emoney'"/>
				<RefundContent v-if="data.ref_type == 'snap_transaksi_refund'"/>
			</template>
    </slotModal>
  </div>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";
import TransaksiContent from "../transaksiContent.vue";
import TopUpContent from "../topUpContent.vue";
import RefundContent from "../refundContent.vue";

export default {
  name: "modalRiwayat",
  components: {
    slotModal,
		TransaksiContent,
		TopUpContent,
		RefundContent,
  },
  data() {
    return {
      modal: false,
			data: {},
    };
  },
  methods: {
    open(data) {
			this.data = data
      this.modal = true;
    },
    close() {
      this.modal = false;
    },
  },
};
</script>
